import { render, staticRenderFns } from "./Stpr.vue?vue&type=template&id=52bc3c7f&scoped=true&"
import script from "./Stpr.vue?vue&type=script&lang=js&"
export * from "./Stpr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc3c7f",
  null
  
)

export default component.exports